module.exports = __webpack_public_path__ + "static/media/ico_tint_mid.eb03caec.svg";